export class GrillePagination<T> {
  criteres: GrilleCriteres;
  data: T;
}

export class GrilleCriteres {
  page: number;
  pages: number;
  skip: number;
  take: number;
  sort: string;
  recherche: string;
  tris: GrilleTri[];
  filtres: GrilleFiltre[];
  count: number;

  public constructor(init?:Partial<GrilleCriteres>) {
      this.tris = [];
      this.filtres = [];
      Object.assign(this, init);
  }
}

export class GrilleTri {
  colonne: string;
  order: string;
  public constructor(init?:Partial<GrilleTri>) {
      Object.assign(this, init);
  }
}

export class GrilleFiltre {
  titre: string;
  colonne: string;
  valeur: string;
  valeur2: string;
  libelle:string;
  operateur: string;
  typeColonne: string;
  public constructor(init?:Partial<GrilleFiltre>) {
      Object.assign(this, init);
  }

  // public libelle() {
  //     return this.titre + this.operateur + this.valeur;
  // }
}

export class GrilleOptions {
  id: string;
  entetes: GrilleColonne[];
  afficherPagination: boolean;
  afficherColonneSelection: boolean;
  barreRechercheActive: boolean;
  afficherFiltresColonnes: boolean;
  filtreColonneActif: boolean;
  taille: string;
  multiTris: boolean;
  masqueDate: string;
  actions: GrilleAction[];
  masquerBoutonInactif: boolean;
  creerActif: boolean = true;
  consulterActif: boolean = true;
  editerActif: boolean = true;
  supprimerActif: boolean = true;
  typeAffichageActions: 'dropdown' | 'bouton' = 'dropdown';



  public constructor(init?:Partial<GrilleOptions>) {
      this.afficherPagination = true;
      this.masquerBoutonInactif = false;
      Object.assign(this, init);
  }

  public static Defaut(id :string) : GrilleOptions {
      let tableOptions = new GrilleOptions({
          id: id,
          afficherPagination: true,
          barreRechercheActive: true,
          afficherFiltresColonnes : false,
          afficherColonneSelection: false,
          filtreColonneActif : false,
          taille : "sm",
          masqueDate: 'yyyy-MM-dd',
          multiTris : false,
          actions : [],
          masquerBoutonInactif: false
      });

      return tableOptions;
  }
}


export class GrilleAction {
  id: string;
  libelle: string;
  icon: string;
  titre: string;
  public constructor(init?:Partial<GrilleAction>) {
      Object.assign(this, init);
  }
}

export class GrilleActionEvent {
  id: string;
  data: any;
}

export class GrilleColonne {
  libelle: string;
  nom: string;
  type = GrilleTypeColonne.Texte; // number, boolean, text
  order: string;
  titreCarte = false;
  filtre: GrilleFiltre;
  triActif = true;
  rechercheActive = true;
  estHyperlien = false;
  colonneHyperlien: string;
  targetHyperlien: string;
  valeursFiltre: any[];
  alignement: GrilleAlignementColonne
  classCss: string;
  operateursFiltre: string[];
  filtreValidation: FiltreValidation;
  tooltip: string;
  checked: boolean;

  public constructor(init?:Partial<GrilleColonne>) {
      this.order = "";
      Object.assign(this, init);
  }
}

export class FiltreValidation {
  message: string;
  pattern: RegExp;
  public constructor(init?:Partial<FiltreValidation>) {
      Object.assign(this, init);
  }
}

export class Operateur {
  libelle: string;
  valeur: string;
  icon: string;
  public constructor(init?:Partial<Operateur>) {
      Object.assign(this, init);
  }
}


export class HyperlienClickEvent {
  colonne: string;
  data: any;
  public constructor(init?:Partial<HyperlienClickEvent>) {
      Object.assign(this, init);
  }
}

export enum GrilleAlignementColonne {
  Gauche,
  Droite,
  Centre
}

export enum GrilleTypeColonne {
  Texte = 'text',
  Nombre = 'number',
  Date = 'date',
  Boolean = 'boolean',
  Montant = 'montant'
}

export enum FiltreTypeOperateur {
  Egal = '=',
  Different = '!=',
  PlusGrand = ">",
  PlusPetit = "<",
  PlusGrandOuEgal = ">=",
  PlusPetitOuEgal = "<=",
  Entre = "entre",
  Contient = "contient",
  ContientPas = "contientpas",
}
